import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';

const GoogleCallback = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { setAuthData } = useAuth();

    useEffect(() => {
        const handleCallback = async () => {
            const token = searchParams.get('token');
            const error = searchParams.get('error');

            if (error) {
                navigate('/login?error=Authentication failed. Please try again.');
                return;
            }

            if (token) {
                try {
                    // Fetch user data with the token
                    const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5001'}/api/auth/me`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });

                    if (response.ok) {
                        const userData = await response.json();

                        // Store token and user data
                        localStorage.setItem('token', token);
                        localStorage.setItem('user', JSON.stringify(userData));

                        // Update auth context if setAuthData is available
                        if (setAuthData) {
                            setAuthData({ token, user: userData });
                        }

                        navigate('/dashboard');
                    } else {
                        navigate('/login?error=Failed to retrieve user information.');
                    }
                } catch (error) {
                    console.error('Error during Google login callback:', error);
                    navigate('/login?error=An error occurred during authentication.');
                }
            } else {
                navigate('/login?error=No authentication token received.');
            }
        };

        handleCallback();
    }, [searchParams, navigate, setAuthData]);

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
            <LoadingSpinner size="lg" text="Completing sign in..." />
        </div>
    );
};

export default GoogleCallback;
